<template>
  <div
    :class="['vault-row clickable', { 'has-divider': hasDivider }]"
    @click="
      $router.push({
        name: 'VaultDetails',
        params: { vault: dataItem.identity.toLowerCase() },
      })
    "
  >
    <div class="d-flex text-5 font-weight-medium align-center pa-6 rounded-24">
      <div class="flex-2 d-flex align-center">
        <img :src="dataItem.icon" alt="" height="36" width="36" />
        <div class="ml-5">
          <div class="text-uppercase">{{ dataItem.identity }}</div>
          <div class="text-6 gray--text mt-2">{{ dataItem.tokenName }}</div>
        </div>
      </div>
      <div class="flex-2 text-right">
        <div>${{ dataItem.totalValueLocked | numberFormat("0,0.00") }}</div>
        <div class="text-6 mt-2">
          <span class="gray--text">24h</span>
          <span
            :class="[
              'ml-1',
              {
                'green--text':
                  dataItem.balanceChange24h.totalValueLocked.percentage > 0,
                'red--text':
                  dataItem.balanceChange24h.totalValueLocked.percentage < 0,
                'darkgray--text':
                  dataItem.balanceChange24h.totalValueLocked.percentage === 0,
              },
            ]"
            ><span></span>
            <span
              ><span v-if="dataItem.balanceChange24h.totalValueLocked.value < 0"
                >–</span
              >${{
                dataItem.balanceChange24h.totalValueLocked.value
                  | abs
                  | numberFormat("0,0.000")
              }}</span
            >
            <span class="ml-1"
              >(<span
                v-if="dataItem.balanceChange24h.totalValueLocked.value < 0"
                >–</span
              ><span v-if="dataItem.balanceChange24h.totalValueLocked.value > 0"
                >+</span
              ><span
                >{{
                  dataItem.balanceChange24h.totalValueLocked.percentage
                    | abs
                    | numberFormat("0,0.00", false)
                }}%</span
              >)</span
            ></span
          >
        </div>
      </div>
      <div class="flex-2 text-right">
        <v-tooltip bottom color="dark" min-width="170">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"
              >{{ dataItem.yield3Days.apy | numberFormat("0,0.00", false) }}%
              APY</span
            >
          </template>
          <div class="text-6">
            <div class="d-flex justify-space-between">
              <div class="opacity-7">Fees ROI</div>
              <div>
                {{
                  dataItem.yield3Days.feesROI | numberFormat("0,0.00", false)
                }}%
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div class="opacity-7">Harvest ROI</div>
              <div>
                {{
                  dataItem.yield3Days.harvestROI
                    | numberFormat("0,0.00", false)
                }}%
              </div>
            </div>
            <v-divider
              style="border-color: white"
              class="mt-2 mb-2"
            ></v-divider>
            <div class="d-flex justify-space-between">
              <span class="opacity-7">{{
                dataItem.yield3Days.bonus >= 0 ? "Slippage" : "Bonus"
              }}</span>
              <span>
                <span v-if="dataItem.yield3Days.bonus"
                  >{{
                    dataItem.yield3Days.bonus
                      | abs
                      | numberFormat("0,0.000000")
                  }}%</span
                >
                <span v-else>-</span>
              </span>
            </div>
          </div>
        </v-tooltip>
        <div class="text-6 mt-2">
          <span class="gray--text">ROI</span>
          <span class="darkgray--text ml-1"
            >{{
              dataItem.yield3Days.ROI | numberFormat("0,0.00", false)
            }}%</span
          >
        </div>
      </div>
      <div class="flex-2 text-right">
        <v-tooltip bottom color="dark" min-width="170">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"
              >{{ dataItem.yield15Days.apy | numberFormat("0,0.00", false) }}%
              APY</span
            >
          </template>
          <div class="text-6">
            <div class="d-flex justify-space-between">
              <div class="opacity-7">Fees ROI</div>
              <div>
                {{
                  dataItem.yield15Days.feesROI | numberFormat("0,0.00", false)
                }}%
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div class="opacity-7">Harvest ROI</div>
              <div>
                {{
                  dataItem.yield15Days.harvestROI
                    | numberFormat("0,0.00", false)
                }}%
              </div>
            </div>
            <v-divider
              style="border-color: white"
              class="mt-2 mb-2"
            ></v-divider>
            <div class="d-flex justify-space-between">
              <span class="opacity-7">{{
                dataItem.yield15Days.bonus >= 0 ? "Slippage" : "Bonus"
              }}</span>
              <span>
                <span v-if="dataItem.yield15Days.bonus"
                  >{{
                    dataItem.yield15Days.bonus
                      | abs
                      | numberFormat("0,0.000000")
                  }}%</span
                >
                <span v-else>-</span>
              </span>
            </div>
          </div>
        </v-tooltip>
        <div class="text-6 mt-2">
          <span class="gray--text">ROI</span>
          <span class="darkgray--text ml-1"
            >{{
              dataItem.yield15Days.ROI | numberFormat("0,0.00", false)
            }}%</span
          >
        </div>
      </div>
      <div class="flex-1 text-right">
        <v-tooltip bottom color="dark">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <img
                :src="dataItem.market.logo"
                height="20"
                width="20"
                :alt="dataItem.market.name"
              />
            </span>
          </template>
          <span>{{ dataItem.market.name }}</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataItem: Object,
    hasDivider: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.vault-row {
  &.has-divider {
    border-top: 1px solid #e3f9ed;
  }
}
</style>
